import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StudentForDiagnosticGradeList } from 'src/app/Elearning-Models';

@Component({
  selector: 'app-diag-exam-list-dialog',
  templateUrl: './diag-exam-list-dialog.component.html',
  styleUrls: ['./diag-exam-list-dialog.component.scss']
})
export class DiagExamListDialogComponent implements OnInit {

  students: StudentForDiagnosticGradeList[];
  title: string;
  constructor(
    public dialogRef: MatDialogRef<DiagExamListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
      this.title = data.title;
      this.students = data.students;
    }

  ngOnInit(): void {
  }

  onCancel = () => {
    this.dialogRef.close();
  }

}
